import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top when route changes
    window.scrollTo(0, 0);
    
    // Cancel any pending animation frames when route changes
    const cancelAnimationFrames = () => {
      // Get all canvas elements that might have animation frames
      const canvasElements = document.querySelectorAll('canvas');
      
      // Force context loss on each canvas to help clean up WebGL resources
      canvasElements.forEach(canvas => {
        // Use the correct type for WebGL context
        const gl = canvas.getContext('webgl') as WebGLRenderingContext || 
                  canvas.getContext('experimental-webgl') as WebGLRenderingContext;
                  
        if (gl) {
          try {
            const loseContext = gl.getExtension('WEBGL_lose_context');
            if (loseContext) {
              loseContext.loseContext();
            }
          } catch (error) {
            console.log('Error while disposing WebGL context:', error);
          }
        }
      });
    };
    
    // Wait a small delay to ensure React has committed the new route
    const timer = setTimeout(() => {
      cancelAnimationFrames();
    }, 100);
    
    return () => {
      clearTimeout(timer);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop; 